import { IconButton, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import {
  SubscriptionProductDto,
  UpdateSubscriptionProductDto,
} from 'tdc-web-backend/subscription-products/schemas';
import { FormProvider, useForm } from 'react-hook-form';
import CustomInput from '../../../../components/custom-input/CustomInput';
import CustomButton from '../../../../components/button/CustomButton';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/button-icons/PlusIcon-Seller-EditModal.svg';
import useUpdate from '../../../../utils/hooks/crud-hooks/useUpdate';
import useGetOne from '../../../../utils/hooks/crud-hooks/useGetOne';
import { ReactComponent as TrashIcon } from '../../../../assets/icons/chat-icons/trash2-fill.svg';
import { primaryDark, secondaryPink } from '../../../../utils/color';
import useDeleteOne from '../../../../utils/hooks/crud-hooks/useDeleteOne';
import BackButton from '../../../../components/button/BackButton';

const AdminSubAddProduct = () => {
  const navigate = useNavigate();
  const { sId } = useParams();

  const formMethods = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',
      maxProjects: 0,
      active: false,
    },
  });

  const { data } = useGetOne<SubscriptionProductDto>({
    resource: `subscription-products/${sId}`,
    enabled: !!sId,
    onSuccess: (data) => {
      formMethods.reset({
        name: data.data.name,
        maxProjects: data.data.maxProjects,
        active: data.data.active,
      });
    },
  });

  const { mutate } = useUpdate<SubscriptionProductDto, UpdateSubscriptionProductDto>({
    resource: 'subscription-products',
  });

  const onSubmit = (data: { name: string; maxProjects: string | number; active: boolean }) => {
    if (!sId) return;
    mutate(
      {
        id: sId,
        data: { ...data, maxProjects: parseInt(data.maxProjects as string, 10) },
      },
      {
        onSuccess: () => {
          navigate('../subscription-products');
        },
      },
    );
  };

  const { mutate: deleteProduct } = useDeleteOne({ resource: 'subscription-products' });

  return (
    <FormProvider {...formMethods}>
      <form>
        <Stack maxWidth="600px" spacing={4}>
          <BackButton onClick={() => navigate('..', { relative: 'path' })} />
          <CustomInput
            name="name"
            input={<CustomInput.Text />}
            label="Name"
            sx={{ minHeight: 'none' }}
            required
          />
          <CustomInput
            name="maxProjects"
            input={<CustomInput.Text />}
            label="Max projects"
            sx={{ minHeight: 'none' }}
            required
          />
          <CustomInput
            name="active"
            input={<CustomInput.Checkbox />}
            label="Active"
            sx={{ minHeight: 'none' }}
          />

          <Stack direction="row" justifyContent="space-between">
            <CustomButton
              variant="primaryLight"
              sx={{
                boxShadow: 'none',
                alignSelf: 'flex-end',
                mt: '10px',
              }}
              onClick={formMethods.handleSubmit(onSubmit)}
              startIcon={<PlusIcon />}
            >
              Save changes
            </CustomButton>

            <CustomButton
              variant="primaryLight"
              sx={{
                boxShadow: 'none',
                alignSelf: 'flex-end',
                mt: '10px',
                color: secondaryPink[500],
                borderColor: secondaryPink[500],
              }}
              onClick={() => {
                if (!sId) return;
                deleteProduct({ id: sId });
                navigate('../subscription-products');
              }}
              startIcon={<TrashIcon fill={secondaryPink[500]} style={{ width: 22, height: 22 }} />}
            >
              Delete product
            </CustomButton>
          </Stack>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default AdminSubAddProduct;
